<mat-form-field style="width: 280px;">
    <mat-label>Name</mat-label>
    <input matInput type="text" [(ngModel)]="value" (keyup)="$event.key == 'Enter' && onSave()">
</mat-form-field>

<div style="align-self: end;">
    <button mat-flat-button (click)="onSave()"><mat-icon>check</mat-icon>Ok</button>
    <button mat-flat-button (click)="dialog.close()"><mat-icon>cancel</mat-icon>Cancel</button>
</div>
